import { RouteSheet } from '@/components/route-sheet';
import { useGetMatchedRoute } from '@/hooks/routing';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(tv)/tv/$id/(device-management)/_sheet')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { id } = Route.useParams();
  const match = useGetMatchedRoute();
  let hasBack = false;
  let backAsRouterNavigateBack = false;
  let title = '';
  const { t } = useI18n();
  if (match.routeId === '/(tv)/tv/$id/(device-management)/_sheet/device-management/') {
    hasBack = false;
    backAsRouterNavigateBack = false;
    title = t('DeviceManagement.Title');
  }

  return (
    <RouteSheet
      onClose={() => navigate({ to: '/tv/$id', params: { id } })}
      options={{ hasBack, backAsRouterNavigateBack, title }}
    />
  );
}
